<div class="dialog-panel message-dialog" [ngStyle]="{ 'border-radius': borderRadius }">
  <div
    class="icon-close"
    [inlineSVG]="closeIconPath ? closeIconPath : '/icons/icon-close-no-color.svg'"
    (click)="closeDialog()"
  ></div>
  @if (title) {
    <div class="dialog-header">
      <h1 class="dialog-title">{{ title }}</h1>
      <span class="page-indicator">{{ pageIndicator }}</span>
    </div>
  }
  <div class="dialog-content" [ngStyle]="{ 'min-height': minHeight }">
    <ng-container *ngTemplateOutlet="content"> </ng-container>
  </div>
  <div class="dialog-actions mt-5">
    @if (dialogWarning) {
      <p class="warning mt-auto">{{ dialogWarning }}</p>
    }

    <ng-container *ngTemplateOutlet="actions || defaultActions"> </ng-container>
  </div>
</div>
<div>
  <ng-template #defaultActions>
    <button [disabled]="disableSubmit" class="Volgende w-100 btn btn-primary" (click)="handleConfirm()">
      @if (btnText) {}
      {{ btnText || 'global.save' | transloco }}
    </button>
  </ng-template>
</div>
